import React from 'react'

export function Spacer() {
  return <div style={{ paddingTop: '1.5rem' }} />
}
